import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n';
import { ScoreRing } from '../ScoreRing';

export const ScoreCard = ({ report, isNew }) => {
  const { t, lang, moveLabel } = useLanguage();

  return (
    <motion.div
      initial={{ opacity: 0, scale: isNew ? 0.96 : 1 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className="ss-card p-6 relative overflow-hidden text-center md:col-span-3"
      data-testid="result-score-card"
    >
      <div className="ss-halo absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(260px circle at 50% 35%, rgba(255,255,255,0.07), transparent 60%)' }} />
      <div className="relative z-10 space-y-3">
        <div className="inline-flex items-center gap-2 rounded-[12px] bg-white/[0.08] border border-white/15 px-3 py-1">
          <span className="font-mono text-xs text-white" data-testid="result-move-label">{moveLabel(report.move_type, report)}</span>
        </div>
        <div className="flex justify-center">
          <ScoreRing score={report.overall_score} size={156} strokeWidth={10} animate={isNew} testId="result-score-value" />
        </div>
        <p className="text-sm text-white/60 max-w-sm mx-auto leading-relaxed" data-testid="result-description">
          {lang === 'it' ? report.detected_description_it : report.detected_description_en}
        </p>
        <div className="font-mono text-[10px] text-white/35 uppercase tracking-wider">
          {t('aiConfidence')}: {(report.confidence * 100).toFixed(0)}%
        </div>
      </div>
    </motion.div>
  );
};
